







import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Store } from "@/store";
import { foldersIn, IBookmarkFolder, BookmarkEntry } from "@/modules/BookMarkModule";

@Component
export default class FolderSelectorComponent extends Vue {
  @Prop({ required: true })
  folder!: IBookmarkFolder

  @Prop({ required: true })
  root!: IBookmarkFolder

  @Prop({ required: true })
  exclude!: BookmarkEntry

  get value() {
    return this.folder
  }

  set value(f: IBookmarkFolder) {
    this.$emit('change', f)
  }

  get folderPaths() {
    return foldersIn(this.root, this.exclude)
  }
}
